import React from "react";
import { parseDateOnly } from "@design-system/DatePicker/DatePicker.lib";
import { getDateRangeLabel } from "@helpers/date";

interface DateFilterLabelProps {
    filters: {
        start?: Date;
        end?: Date;
        startDate?: string;
        endDate?: string;
    };
}
export const DateFilterLabel: React.FC<DateFilterLabelProps> = ({
    filters: { start, end, startDate, endDate },
}) => (
    <>
        {getDateRangeLabel(
            parseDateOnly(startDate) ?? start,
            parseDateOnly(endDate) ?? end,
        )}
    </>
);
